import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-analytics-popup',
  templateUrl: './analytics-popup.component.html',
  styleUrls: ['./analytics-popup.component.scss']
})
export class AnalyticsPopupComponent implements OnInit {
  dataToShow:Array<Record<string, string>> = [];
  title!: string
  hasDuration: boolean = false;
  count:string[] = [];
  duration:string[] = [];
  metricsName = "Count";

  ngOnInit(): void {}

  constructor(
    public dialogRef: MatDialogRef<AnalyticsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if(data && data.hasOwnProperty("dataToShow") && (Object.keys(data.dataToShow).length > 0)){
      Object.entries(data.dataToShow).forEach(([key, value])=> {
        let count = value;
        let duration = '';

        if (typeof value === 'string' && value.includes("/")){
          const strArr = value.split("/").map(str => str.trim()); //trim spaces
          count = strArr[0].trim();
          duration = strArr[1].trim();
        }

        this.dataToShow.push({ key, count: String(count), ...(duration && { duration }) });
      })
    }

    if(data.title === "Match+" || data.title === "Player+" || data.title === "Stats+" || data.title === "Timeline+" || data.title === "Multi"){
      this.metricsName = "Percentage"
    }

    this.title = data.title;
  }

  onClose(): void {
    // this.dialogRef.close();
  }

}
